var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { StringUtilities } from "../../../utilities/strings";
import * as Enumerable from "linq";
var Legend = /** @class */ (function () {
    function Legend(element) {
        this.element = element;
        this.format = "{0}";
        this.params = "label";
    }
    Object.defineProperty(Legend.prototype, "entries", {
        get: function () {
            return this.data ? Enumerable.from(this.data).where(function (x) { return x.label == "All"; })
                .concat(Enumerable.from(this.data).where(function (x) { return x.label != "All"; })
                .orderByDescending(function (x) { return x.data; })).toArray() : [];
        },
        enumerable: false,
        configurable: true
    });
    Legend.prototype.clickItem = function (item, index) {
        var paramsEvent = { detail: { label: item.label, index: index, isLengend: true }, bubbles: true };
        var chartItemClick = new CustomEvent("legend-item-click", paramsEvent);
        this.element.dispatchEvent(chartItemClick);
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], Legend.prototype, "data", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Legend.prototype, "format", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Legend.prototype, "params", void 0);
    Legend = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [Element])
    ], Legend);
    return Legend;
}());
export { Legend };
var LegendStringFormatValueConverter = /** @class */ (function () {
    function LegendStringFormatValueConverter() {
    }
    LegendStringFormatValueConverter.prototype.toView = function (value, args) {
        var item = value;
        var format = args.format;
        var params = args.params.split(',');
        for (var i = 0; i < params.length; i++) {
            var index = "{" + i + "}";
            var regex = new RegExp(StringUtilities.escapeRegExp(index), 'g');
            format = format.replace(regex, this.getLocaleFormatValue(item[params[i]]));
        }
        return format;
    };
    //format the value if number to locale
    LegendStringFormatValueConverter.prototype.getLocaleFormatValue = function (data) {
        if (!isNaN(parseFloat(data)) && isFinite(data)) {
            return Number(data).toLocaleString();
        }
        else
            return data;
    };
    return LegendStringFormatValueConverter;
}());
export { LegendStringFormatValueConverter };
